import initializeSelectDocuments from './initialize-select-documents'

export default () => initializeSelectDocuments()
